import { infoColor, infoBoxShadow, whiteColor } from '../global';

const detailSeminarCompanyStyle = (theme) => ({
    booth: {
        borderRadius: '8px',
        ...infoBoxShadow,
        borderColor: infoColor,
        paddingLeft: '20px',
        paddingRight: '20px',
        width: '100%',
        height: '100%',
    },
    image: {
        borderRadius: '8px',
        ...infoBoxShadow,
        borderColor: infoColor,
        margin: 15,
        height: 200,
    },
    wrapper: {
        backgroundColor: whiteColor,
    },
    marginBt5vh: {
        marginBottom: '5vh',
    },
    paddingLefe3vW: {
        paddingLeft: '3vW',
    },
    paddingTop5vh: {
        paddingTop: '5vh',
    },
    textCenter: {
        textAlign: 'center',
    },
    textLeft: {
        textAlign: 'left',
    },
    displayTextInline: {
        display: 'inline',
    },
    formInputInformation: {
        maxWidth: '1000px',
        border: '1px solid',
        ...infoBoxShadow,
        marginLeft: 'auto',
        marginRight: 'auto',
        zIndex: 20,
        background: whiteColor,
        borderColor: infoColor,
        borderRadius: '1%',
        paddingTop: '5vh',
    },
    background: {
        minHeight: '700px',
        overflow: 'hidden',
        position: 'relative',
        zIndex: '1',
        backgroundColor: whiteColor,
        display: 'flex',
        borderRadius: '8px',
        [theme.breakpoints.up('md')]: {
            backgroundImage: 'url("/resources/mask_group.png")',
            backgroundPosition: 'left',
            backgroundSize: 'auto',
            backgroundRepeat: 'no-repeat',
        },
    },
    spacing: {
        padding: '15px 0',
    },
    padding15: {
        padding: '15px 15px 0px 0px',
    },
    note: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    tooltipStyle: {
        marginTop: -10,
        padding: 0,
    },
    number: {
        color: whiteColor,
        background: 'orange',
        borderRadius: '50%',
        width: '25px',
        height: '25px',
        minWidth: '25px',
        textAlign: 'center',
        fontWeight: 700,
        padding: 2,
        fontSize: '1rem',
    },
    noteContent: {
        paddingLeft: theme.spacing(1.25),
        paddingRight: 0,
    },
    maxHeight: {
        maxHeight: 220,
    },
    maxWidth50: {
        [theme.breakpoints.up('md')]: { maxWidth: '50%' },
    },
    paddingLeft11: {
        paddingLeft: '11px',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    price: {
        '&:after': {
            content: '"円"',
            transform: 'translateX(calc(100% + 10px))',
        },
    },
    name: {
        '& input': {
            padding: '10px',

            '&::-webkit-inner-spin-button': {
                opacity: 1, // Always show spin buttons on Chrome
            },
        },
    },
});

export default detailSeminarCompanyStyle;
